import * as React from 'react';
import * as R from 'ramda';
import { combineClassNames } from '../../utils/combineClassNames';

export type Props = {
  name?: (string | { props: { children: any } }),
  shortName?: string,
  size: number,
  color?: string,
  className?: string,
};

export const getShortName = (name: string) => {
  if (!name || name === '"Verwijderde gebruiker"' || name === '"Verwijderd"') return '?';

  const parts = name.split(/[\s-]/);

  return R.pipe(
    R.map((string: string) => string.substr(0, 1)),
    R.join(''),
    R.toUpper,
  )(parts.length === 1 ? parts : [parts[0], parts[parts.length - 1]]);
};

const ImagePlaceholder = ({
 name, shortName, size, color, className, ...props
}: Props) => {
  const computedShortName = getShortName(name && (typeof name === 'string' ? name : name.props.children));
  const displayedShortName = (typeof shortName === 'string' && shortName.trim())
    ? shortName.trim().slice(0, 2).toUpperCase()
    : computedShortName;

  return (
    <div
      {...props}
      className={combineClassNames('ImagePlaceholder', className)}
      style={{
        width: `${size}px`,
        height: `${size}px`,
        lineHeight: `${size}px`,
        backgroundColor: color,
      }}
    >
      {displayedShortName}
    </div>
  );
};

ImagePlaceholder.defaultProps = {
  name: '?',
};

export default ImagePlaceholder;
